module.exports = __webpack_public_path__ + "static/media/brayan.c702297e.jpg";